<m-message-page :state="state"
                :svg-name="svgName"
                :title="title"
                :hints="hints"
                :links="links">
</m-message-page>
